/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 InputBase, NS/Tractie input-pendant overrides.
// Tractie source: input (basis).
// Cluster 13 control-sizing tokens drive height/padding.
//
// Reset-checklist (subtractive-first):
//   - MUI default border via `notchedOutline`: niet relevant voor InputBase (zit op OutlinedInput).
//   - MUI default focus-styling op input-inner: GENEUTRALISEERD. Per ground-rules.md
//     "Focus" hoort de focus-indicator op de root, niet op de
//     inner input-node. Inner-rule is leeg gelaten met annotation; focus-formule staat
//     op `root` via `&$focused` selector — identiek aan OutlinedInput precedent
//     (mui-outlined-input-overrides.ts:81-86, commit 6ab30c9).
//   - MUI default transition: vervangen door `none` (Tractie geen animaties).
//
// Focus-formule canonical (Tractie):
//   outline: var(--ns-border-width-medium) solid var(--ns-color-border-focus)
//   outlineOffset: calc(-1 * var(--ns-border-width-medium))   // INSET
//   boxShadow: var(--ns-shadow-elevated-1)
//
// Mode-split: Dark spreads Light (no mode-specific divergences for InputBase basis).

export const MuiInputBaseLightOverrides = {
  root: {
    minHeight: 'var(--ns-control-height-m)',
    backgroundColor: 'var(--ns-color-bg-input)',
    color: 'var(--ns-color-fg-default)',
    borderRadius: 'var(--ns-control-radius)',
    transition: 'none',
    // Force-class variant (foundation T1.3) allows comparison-grid stories to
    // visually render the focus-visible row by setting className="force-focus-visible"
    // on the Input element. See packages/storybook-utils/src/comparison/force-state.ts.
    // T1.4 (2026-05-25): MuiInputBase focus styling verwijderd; focus-indicator
    // verschoven naar notchedOutline borderColor change (per MuiOutlinedInput
    // override). Pariteit met Tractie clean border-only pattern.
    '&$focused, &.force-focus-visible': {
      boxShadow: 'none',
      outline: 'none',
    },
    // T1.4 (2026-05-22): Tractie + BUI dimmen NIET op disabled. MUI default
    // opacity 0.5 → all dim. Set 1 voor pariteit met Tractie. Disabled
    // visual intent via input cursor + read-only behavior.
    '&$disabled': {
      opacity: 1,
      pointerEvents: 'none' as const,
    },
  },

  input: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
    padding: 'var(--ns-control-padding-y-m) var(--ns-control-padding-x-m)',
    color: 'var(--ns-color-fg-default)',
    caretColor: 'var(--ns-color-fg-default)',
    '&::placeholder': {
      color: 'var(--ns-color-fg-subtle)',
      opacity: 1,
    },
    // reason: focus naar root verplaatst per ground-rules.md "Focus".
    // Geen `&:focus-visible` of `&:focus` rule hier — anders ontstaat dubbele indicator
    // (root-outline + inner-outline) en drift met OutlinedInput precedent.
  },

  focused: {},
  disabled: {},
  error: {},
  formControl: {},
  adornedStart: {},
  adornedEnd: {},
  marginDense: {},
  multiline: {},
  fullWidth: {},
  colorSecondary: {},
  inputMarginDense: {},
  inputMultiline: {},
  inputTypeSearch: {},
  inputAdornedStart: {},
  inputAdornedEnd: {},
  inputHiddenLabel: {},
} as const;

export const MuiInputBaseDarkOverrides = {
  ...MuiInputBaseLightOverrides,
} as const;
